import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const IdentifySkinColor = lazyWithPreload(
  () => import('./IdentifySkinColor'),
)
